// Bordered Section Border Animation
class BorderedSectionAnimation {
  constructor() {
    // main要素内のセクションのみを対象（ヘッダーとフッターを除外）
    this.sections = document.querySelectorAll('.global_top main .shopify-section:not(:last-child)');
    if (this.sections.length === 0) return;
    this.init();
  }

  init() {
    this.setupBorderAnimation();
  }

  setupBorderAnimation() {
    const animatedSections = new Set(); // アニメーション済みのセクションを記録

    // スクロール時にセクションの下部が画面に入ったかチェック
    const checkBorderVisibility = () => {
      this.sections.forEach(section => {
        if (animatedSections.has(section)) return; // 既にアニメーション済みの場合はスキップ

        const rect = section.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // セクションの下部（ボーダー位置）が画面に入った時（画面の下部に到達した時）にアニメーション開始
        if (rect.bottom > 0 && rect.bottom <= viewportHeight) {
          section.classList.add('animate-border');
          animatedSections.add(section);
        }
      });
    };

    // 初期チェック
    checkBorderVisibility();

    // スクロール時にチェック（パフォーマンスを考慮してthrottle）
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          checkBorderVisibility();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', checkBorderVisibility, { passive: true });
  }
}

// Initialize function
function initBorderedSectionAnimation() {
  new BorderedSectionAnimation();
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBorderedSectionAnimation);
} else {
  initBorderedSectionAnimation();
}

// Shopify theme editor support
document.addEventListener('shopify:section:load', initBorderedSectionAnimation);
document.addEventListener('shopify:section:reorder', initBorderedSectionAnimation);

